import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { resetToken } from '../../reducetool/features/authSlice';
import { allRemoveItem } from '../../reducetool/features/cardSlice';
import InfoModal from './InfoModal';

const MyRewards = () => {
    const navigate = useNavigate();
    const authData = useSelector(state => state.authState);
    const [userDetail, setUserDetail] = useState(authData.user);

    const [rewardCardList, setRewardCardList] = useState([]);
    const [isViewInfo, setIsViewInfo] = useState(false);
    const [contributorInfo, setContributorInfo] = useState({});

    const onHanldeLevelInfo = (data) => {
        setIsViewInfo(true);
        setContributorInfo(data);
        //document.body.classList.add("modal-open-blur");
    }
    const handleInfoClose = () => {
        setIsViewInfo(false);
        //document.body.classList.remove("modal-open-blur");
    }

    useEffect(() => {

        if (authData.login) {
            getRewardCardList()
        }
    }, [])

    const getRewardCardList = async () => {

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`/api/TreeTesting/GetUserClaimRewardCards?userMob=${userDetail.user_mobile}`, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            console.log(response)

            if (response.status === true) {
                setRewardCardList(response.rewardCardDataList);
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    return (
        <>
            <section className="user-dashboard-section section-b-space">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-xxl-12 col-lg-12">
                            <div className="dashboard-card">
                                <div className="title title-flex">
                                    <div>
                                        <h2>Claim your Rewards</h2>
                                        <span className="title-leaf">
                                            <svg className="icon-width bg-gray">
                                                <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                            </svg>
                                        </span>
                                    </div>
                                </div>


                                <div className="row g-4">

                                    {rewardCardList.map((item) => {
                                        return (
                                            <>
                                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12">
                                        <div className="seller-grid-box seller-grid-box-1 shadow mb-0">
                                            {/* <i className="fa fa-info-circle float-end"></i> */}

                                            <div className="grid-image">
                                                {/* <div className="image">
                                                    <img
                                                        src="../assets/images/vendor-page/logo/2.png"
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </div> */}
                                                    <h3>{item.reward_msg}</h3>

                                                <div className="contain-name">
                                                   
                                                    <div className='row'>
                                                        <div className='col'>
                                                            <div className="since-number">
                                                                <h6>Amount Earned</h6>
                                                            </div>
                                                            <h3 className='text-success'>₹{item.lv_completion_amt}</h3>
                                                        </div>

                                                        {/* <div className='col'>
                                                            <div className="since-number">
                                                                <h6>Reward Card no.</h6>
                                                            </div>
                                                            <h3>{item.reward_card_no}</h3>
                                                        </div> */}
                                                        

                                                    </div>

                                                    {/* <label className="product-label">Reward Card no. {item.reward_card_no}</label> */}
                                                    {/* <label className="product-label"> From : Level {item.level_no} | Stage {item.stage_no}</label> */}
                                                    <button className="btn btn-md bg-theme text-white mt-3 float-end">Claim now</button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>             

                                            </>)
                                    })}

                                                                                                                                                  </div>


                                <div className="title title-flex mt-3">
                                    <div>
                                        <h2>Rewards History</h2>
                                        <span className="title-leaf">
                                            <svg className="icon-width bg-gray">
                                                <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                            </svg>
                                        </span>
                                    </div>
                                </div>

                                <div className="row g-4">
                                    <table class="table shadow">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Card no.</th>
                                                <th scope="col">Claimed by</th>
                                                <th scope="col">Claiming Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rewardCardList.length ? rewardCardList.map((item, index) => {
                                                (
                                                    <>
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.username}</td>
                                                            <td>{item.sponsor}</td>
                                                            <td>{item.joiningDate}</td>
                                                        </tr>
                                                    </>
                                                )
                                            })
                                                :
                                                (
                                                    <>
                                                        <tr>

                                                            <td colSpan={4} className="text-center">No data available</td>
                                                        </tr>
                                                    </>
                                                )
                                            }



                                        </tbody>
                                    </table>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
            </section>


            {isViewInfo &&
                <InfoModal
                    contributorInfo={contributorInfo}
                    handleInfoClose={handleInfoClose} />
            }
        </>)

}

export default MyRewards;